// extracted by mini-css-extract-plugin
module.exports = {"cardAccordionHeader":"AccordionToggle_cardAccordionHeader__1Cd1y","accordion":"AccordionToggle_accordion__tmn4C"};